interface IPriority {
  priority: number;
}

export function sortByPriority(a: IPriority, b: IPriority) {
  return a.priority - b.priority;
}
